'use client'
import { useState, useEffect } from 'react'
import { usePathname } from 'next/navigation'
import Hero from 'components/Hero'
import Feature from 'components/Feature'
import Disclosure from 'components/Disclosure'
import DisclosurePlus from 'components/DisclosurePlus'
import Downloads from 'components/Downloads'
import TextBlock from 'components/TextBlock'
import TextStyles from 'components/TextStyles'
import Buttons from 'components/Buttons'
import CardsBlock from 'components/CardsBlock'
import Banner from 'components/Banner'
import Slider from 'components/Slider'
import ProfilesList from 'components/ProfilesList'
import Scorer from 'components/Scorer'
import { STRAPI } from 'config/apis'

const TemplatePage = () => {
  const [components, setComponents] = useState({})
  const [show404, setShow404] = useState(false)
  const pathname = usePathname()

  const getData = async () => {
    try {
      const reqPage = await fetch(STRAPI.PAGE.replace('{link}', pathname))
      const components = await reqPage.json()
      if (components) {
        setComponents(components.data.pop())
      } else {
        setShow404(true)
      }
    } catch (error) {}
  }

  useEffect(() => {
    getData()
  }, [])

  return (
    <>
      {!show404 ? (
        components?.attributes?.items?.length ? (
          components.attributes.items.map((c, idx) => {
            if (c.__component === 'ui.hero') {
              return (
                <Hero
                  key={idx}
                  media={c.media.data.attributes}
                  text={c.titulo}
                  ctaText={c.cta?.texto}
                  ctaLink={c.cta?.link}
                  ctaExternal={c.cta?.externo}
                />
              )
            } else if (c.__component === 'ui.img-and-text') {
              return (
                <Feature
                  key={idx}
                  title={c.titulo}
                  excerpt={c.extracto}
                  img={c.imagen.data.attributes.url}
                  ctaText={c.cta?.titulo}
                  ctaLink={c.cta?.link}
                  ctaExternal={c.cta?.externo}
                  order={c.orden}
                  small={c.altura_mini}
                />
              )
            } else if (c.__component === 'ui.faqs') {
              return <Disclosure key={idx} items={c.items} />
            } else if (c.__component === 'ui.descargas') {
              return <Downloads key={idx} data={c} />
            } else if (c.__component === 'ui.bloque-texto') {
              return <TextBlock key={idx} data={c} />
            } else if (c.__component === 'ui.texto-libre') {
              return <TextStyles key={idx} data={c.texto} />
            } else if (c.__component === 'ui.botones') {
              return <Buttons key={idx} data={c.items} />
            } else if (c.__component === 'ui.desplegable-plus') {
              return <DisclosurePlus key={idx} items={c.items} />
            } else if (c.__component === 'ui.cards') {
              return <CardsBlock key={idx} items={c.items} />
            } else if (c.__component === 'ui.banner') {
              return (
                <Banner
                  key={idx}
                  img={c.imagen?.data?.attributes?.url}
                  imgMobile={c.imagen_movil?.data?.attributes?.url}
                  link={c.link}
                />
              )
            } else if (c.__component === 'ui.slider') {
              return <Slider key={idx} items={c.sliders} />
            } else if (c.__component === 'ui.listado-de-perfiles') {
              return <ProfilesList key={idx} data={c} />
            } else if (c.__component === 'ui.scorer') {
              return <Scorer key={idx} data={c} />
            }
          })
        ) : null
      ) : (
        <>404</>
      )}
    </>
  )
}

export default TemplatePage
